<template>
  <div class="page-wrapper mt-3" style="width: 100%">
    <PageTitle title="Мониторинг и аналитика результатов автопроверки" />
    <!-- БЛОК ФИЛЬТРОВ И ДЕЙСТВИЙ -->
    <v-card variant="outlined" class="ma-2 pa-4 bg-white rounded-lg">
      <div class="d-flex flex-column gap-4">
        <!-- Селект группы (Строка 1) -->
        <div style="width: 100%;">
          <v-select
            class="ma-2"
            v-model="selectedGroupId"
            :items="groups"
            item-title="personGroupName"
            item-value="id"
            label="Учебная группа студентов"
            clearable
            variant="outlined"
            density="compact"
            hide-details
            @update:model-value="onFilterChange"
          ></v-select>
        </div>
        <!-- Селект курса (Строка 2) -->
        <div style="width: 100%;">
          <v-select
            class="ma-2"
            v-model="selectedCourseId"
            :items="courses"
            item-title="courseName"
            item-value="id"
            label="Курс обучения"
            clearable
            variant="outlined"
            density="compact"
            hide-details
            @update:model-value="onCourseFilterChange"
          ></v-select>
        </div>
        <!-- Селект Модуля (Строка 3 - появляется, только если выбран курс) -->
        <div style="width: 100%;" v-if="selectedCourseId && courseFilterData.length > 0">
          <v-select
            class="ma-2"
            v-model="selectedModuleId"
            :items="courseFilterData"
            item-title="moduleName"
            item-value="id"
            label="Модуль курса"
            clearable
            variant="outlined"
            density="compact"
            hide-details
            @update:model-value="onModuleFilterChange"
          ></v-select>
        </div>
        <!-- Селект Предмета (Строка 4 - появляется, только если выбран модуль) -->
        <div style="width: 100%;" v-if="selectedModuleId && availableSubjects.length > 0">
          <v-select
            class="ma-2"
            v-model="selectedSubjectId"
            :items="availableSubjects"
            item-title="subjectName"
            item-value="id"
            label="Предмет"
            clearable
            variant="outlined"
            density="compact"
            hide-details
            @update:model-value="onSubjectFilterChange"
          ></v-select>
        </div>
        <!-- Селект Пробы (Строка 5 - появляется, только если выбран предмет) -->
        <div style="width: 100%;" v-if="selectedSubjectId && availableProbes.length > 0">
          <v-select
            class="ma-2"
            v-model="selectedProbeId"
            :items="availableProbes"
            item-title="probeName"
            item-value="id"
            label="Проба"
            clearable
            variant="outlined"
            density="compact"
            hide-details
            @update:model-value="onFilterChange"
          ></v-select>
        </div>
        <!-- Блок действий (Нижняя строка, кнопки прижаты влево или вправо по вкусу) -->
        <div class="d-flex align-center gap-2 pt-2 border-top">
          <v-btn
            prepend-icon="mdi-refresh"
            variant="outlined"
            color="secondary"
            density="comfortable"
            class="font-weight-bold"
            style="min-width: 110px;"
            @click="onFilterChange"
          >
            Обновить
          </v-btn>
          <v-btn
            :disabled="results.length === 0"
            prepend-icon="mdi-file-excel"
            color="success"
            variant="flat"
            density="comfortable"
            class="font-weight-bold"
            @click="downloadReport('excel')"
          >
          Все пробы в XLS
          </v-btn>
          <v-btn
            :disabled="results.length === 0"
            prepend-icon="mdi-file-document-outline"
            color="success"
            variant="flat"
            density="comfortable"
            class="font-weight-bold"
            @click="downloadReport('pdf')"
          >
           Все пробы в PDF
          </v-btn>
           <v-btn
              :disabled="results.length === 0"
              prepend-icon="mdi-file-document-outline"
              color="success"
              variant="flat"
              density="comfortable"
              class="font-weight-bold"
              @click="downloadReport('doc')"
           >
             Все пробы в DOCX
           </v-btn>
        </div>
      </div>
    </v-card>
    <!-- ИНФОРМАЦИОННЫЕ КАРТОЧКИ АНАЛИТИКИ -->
    <v-row class="ma-1" v-if="stats">
      <v-col cols="12" sm="6" md="3" class="pa-1">
        <v-card variant="outlined" class="pa-3 bg-white border-left-blue rounded-lg">
          <div class="d-flex justify-space-between align-center">
            <div>
              <span class="text-caption text-grey d-block">Всего отправлено</span>
              <span class="text-h5 font-weight-bold">{{ stats.totalSubmitted }} шт.</span>
            </div>
            <v-icon color="blue" size="large">mdi-file-upload-outline</v-icon>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="pa-1">
        <v-card variant="outlined" class="pa-3 bg-white border-left-green rounded-lg">
          <div class="d-flex justify-space-between align-center">
            <div>
              <span class="text-caption text-grey d-block">Успешно проверено</span>
              <span class="text-h5 font-weight-bold text-success">{{ stats.totalChecked }} шт.</span>
            </div>
            <v-icon color="success" size="large">mdi-check-circle-outline</v-icon>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="pa-1">
        <v-card variant="outlined" class="pa-3 bg-white border-left-amber rounded-lg">
          <div class="d-flex justify-space-between align-center">
            <div>
              <span class="text-caption text-grey d-block">В очереди / работе</span>
              <span class="text-h5 font-weight-bold text-amber-darken-3">{{ stats.totalInWork }} шт.</span>
            </div>
            <v-icon color="amber-darken-3" size="large">mdi-progress-clock</v-icon>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="pa-1">
        <v-card variant="outlined" class="pa-3 bg-white border-left-purple rounded-lg">
          <div class="d-flex justify-space-between align-center">
            <div>
              <span class="text-caption text-grey d-block">Средний балл группы</span>
              <span class="text-h5 font-weight-bold text-purple">{{ stats.averageGrade }}</span>
            </div>
            <v-icon color="purple" size="large">mdi-calculator-variant-outline</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- СТРОКА ОПЕРАТИВНОГО ПОИСКА ПО ТАБЛИЦЕ -->
    <v-card variant="outlined" class="ma-2 pa-2 bg-white rounded-lg">
      <v-text-field
        v-model="tableSearch"
        prepend-inner-icon="mdi-text-search-outline"
        label="Быстрый поиск студента по ФИО в текущем списке..."
        variant="underlined"
        density="compact"
        hide-details
        clearable
      ></v-text-field>
    </v-card>
    <!-- ТАБЛИЦА РЕЗУЛЬТАТОВ -->
    <div class="page-wrapper mt-2 w-100">
      <v-row class="ma-1 mt-4">
        <!-- КОЛОНКА 1: ЧЕРНОВИКИ (DRAFT) -->
        <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="pa-2">
          <v-card variant="flat" color="grey-lighten-4" class="pa-3 rounded-lg h-100">
            <div class="d-flex align-center justify-space-between mb-3">
              <span class="text-subtitle-1 font-weight-bold text-grey-darken-3">📝 Черновики</span>
              <v-badge color="grey" :content="getColCount('DRAFT')" inline class="font-weight-bold"></v-badge>
            </div>
            <v-divider class="mb-3"></v-divider>
            <div class="kanban-scroll-zone">
              <v-card v-for="item in getColItems('DRAFT')" :key="item.esseId" class="mb-2 pa-3 rounded-lg border bg-white" variant="flat">
                <div class="font-weight-bold text-body-2">{{ item.studentFullName }}</div>
                <div class="text-caption text-grey mt-1">Модуль: {{ item.moduleName }}</div>
                <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                  Предмет: {{ item.subjectName }}
                </div>
                <div class="text-caption text-grey  w-100" style="max-width: 100%;">
                  Проба: {{ item.probeName }}
                </div>
                <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                  Попытка: {{ item.attempt }}
                </div>
                <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                  Промпт id: {{ item.promptId }}
                </div>
                <div class="text-caption text-grey  w-100" style="max-width: 100%;">
                  Промпт: {{ item.promptName }}
                </div>
                <div class="text-caption text-grey-lighten-1 mt-1">{{ formatDateTime(item.createdAt) }}</div>
                 <!-- Нижняя часть карточки -->
                 <div class="mt-3 pt-2 border-top-light">
                  <div class="d-flex align-center justify-space-between w-100">
                    <!-- Левая часть:  маркер статуса -->
                    <div class="flex-grow-1 mr-2 text-truncate">

                    </div>
                    <!-- Правая часть: Блок иконок -->
                    <div class="d-flex align-center gap-1 flex-grow-0 flex-shrink-0">
                      <v-btn
                       icon="mdi-file-document-outline"
                       size="x-small"
                       variant="tonal"
                       color="deep-orange-darken-1"
                       density="comfortable"
                       class="rounded-md ma-1"
                       style="min-width: 28px; width: 28px; height: 28px;"
                       title="Скачать"
                        @click="downloadDocument(item)"
                      ></v-btn>
                      <v-btn
                        icon="mdi-cached"
                        size="x-small"
                        variant="outlined"
                        color="info"
                        density="comfortable"
                        class="rounded-md ma-1"
                        style="min-width: 28px; width: 28px; height: 28px;"
                        title="Запустить повторную проверку ИИ"
                        @click="recheckEssay(item.esseId)"
                      ></v-btn>
                    </div>
                  </div>
                </div>
              </v-card>
              <div v-if="getColCount('DRAFT') === 0" class="text-center text-caption text-grey py-4 font-italic">Пусто</div>
            </div>
          </v-card>
        </v-col>
        <!-- КОЛОНКА 2: В ОЧЕРЕДИ (SENT) -->
        <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="pa-2">
          <v-card variant="flat" color="amber-lighten-5" class="pa-3 rounded-lg h-100">
            <div class="d-flex align-center justify-space-between mb-3">
              <span class="text-subtitle-1 font-weight-bold text-amber-darken-4">⏳ В очереди</span>
              <v-badge color="amber-darken-3" :content="getColCount('SENT')" inline class="font-weight-bold"></v-badge>
            </div>
            <v-divider class="mb-3"></v-divider>
            <div class="kanban-scroll-zone">
              <v-card v-for="item in getColItems('SENT')" :key="item.esseId" class="mb-2 pa-3 rounded-lg border bg-white border-left-amber" variant="flat">
                <div class="font-weight-bold text-body-2">{{ item.studentFullName }}</div>
                <div class="text-caption text-grey mt-1">Модуль: {{ item.moduleName }}</div>
                <v-chip size="x-small" color="warning" class="mt-2 font-weight-bold" variant="flat">Ожидает проверки</v-chip>
              </v-card>
              <div v-if="getColCount('SENT') === 0" class="text-center text-caption text-grey py-4 font-italic">Пусто</div>
            </div>
          </v-card>
        </v-col>
        <!-- КОЛОНКА 3: В РАБОТЕ ИИ (IN_WORK) -->
        <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="pa-2">
          <v-card variant="flat" color="blue-lighten-5" class="pa-3 rounded-lg h-100">
            <div class="d-flex align-center justify-space-between mb-3">
              <span class="text-subtitle-1 font-weight-bold text-blue-darken-3">🤖 В работе ИИ</span>
              <v-badge color="blue" :content="getColCount('IN_WORK')" inline class="font-weight-bold"></v-badge>
            </div>
            <v-divider class="mb-3"></v-divider>
            <div class="kanban-scroll-zone">
              <v-card v-for="item in getColItems('IN_WORK')" :key="item.esseId" class="mb-2 pa-3 rounded-lg border bg-white border-left-blue" variant="flat">
                <div class="font-weight-bold text-body-2">{{ item.studentFullName }}</div>
                <div class="text-caption text-grey mt-1">Модуль: {{ item.moduleName }}</div>
                <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                  Промпт id: {{ item.promptId }}
                </div>
                <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                  Промпт: {{ item.promptName }}
                </div>
                <div class="d-flex align-center text-caption text-deep-orange-darken-1 font-weight-bold mt-2">
                  <v-progress-circular indeterminate size="16" width="2" class="mr-2"></v-progress-circular>
                  Проверяется...
                </div>
                <div class="mt-3 pt-2 border-top-light">
                  <div class="d-flex align-center justify-space-between w-100">
                    <!-- Левая часть:  маркер статуса -->
                    <div class="flex-grow-1 mr-2 text-truncate">
                    </div>
                    <!-- Правая часть: Блок иконок -->
                    <div class="d-flex align-center gap-1 flex-grow-0 flex-shrink-0">
                      <v-btn
                        icon="mdi-file-document-outline"
                        size="x-small"
                        variant="tonal"
                        color="deep-orange-darken-1"
                        density="comfortable"
                        class="rounded-md ma-1"
                        style="min-width: 28px; width: 28px; height: 28px;"
                        title="Скачать"
                        @click="downloadDocument(item)"
                      ></v-btn>
                      <v-btn
                        icon="mdi-cached"
                        size="x-small"
                        variant="outlined"
                        color="info"
                        density="comfortable"
                        class="rounded-md ma-1"
                        style="min-width: 28px; width: 28px; height: 28px;"
                        title="Запустить повторную проверку ИИ"
                        @click="recheckEssay(item.esseId)"
                      ></v-btn>
                      <v-btn
                        icon="mdi-delete"
                        size="x-small"
                        variant="outlined"
                        color="red"
                        density="comfortable"
                        class="rounded-md ma-1"
                        style="min-width: 28px; width: 28px; height: 28px;"
                        title="Удалить"
                        @click="deleteEssay(item.esseId)"
                      ></v-btn>
                    </div>
                  </div>
                </div>
              </v-card>
              <div v-if="getColCount('IN_WORK') === 0" class="text-center text-caption text-grey py-4 font-italic">Пусто</div>
            </div>
          </v-card>
        </v-col>
        <!-- КОЛОНКА 4: ПРОВЕРЕНО ИИ (CHECKED / FAIL_CHECK / SYSTEM_ERROR) -->
        <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="pa-2">
          <v-card variant="flat" color="green-lighten-5" class="pa-3 rounded-lg h-100 d-flex flex-column">
            <!-- Шапка колонки -->
            <div class="d-flex align-center justify-space-between mb-3">
              <span class="text-subtitle-1 font-weight-bold text-green-darken-3">✅ Проверено</span>
              <v-badge color="green" :content="getColCount('CHECKED')" inline class="font-weight-bold"></v-badge>
            </div>
            <v-divider class="mb-3"></v-divider>
            <!-- Скролл-зона с карточками студентов -->
            <div class="kanban-scroll-zone flex-grow-1">
              <v-card
                v-for="item in getColItems('CHECKED')"
                :key="item.esseId"
                class="mb-2 pa-3 rounded-lg border bg-white d-flex flex-column justify-space-between"
                :class="item.status === 'FAIL_CHECK' || item.status === 'SYSTEM_ERROR' ? 'border-left-red' : 'border-left-green'"
                variant="flat"
                style="min-height: 140px;"
              >

                <!-- Верхняя часть карточки: ФИО и Оценка -->
                <div>
                  <div class="d-flex justify-space-between align-start w-100 mb-1">
                    <!-- ФИО студента (переносится по словам, если не влезает) -->
                    <div class="font-weight-bold text-body-2 pr-2 text-wrap" style="word-break: break-word; line-height: 1.3;">
                      {{ item.studentFullName }}
                    </div>
                    <!-- Вывод итоговой оценки или плашки сбоя -->
                    <v-chip
                      v-if="item.status === 'CHECKED'"
                      size="x-small"
                      color="success"
                      variant="flat"
                      class="font-weight-bold px-2 py-2"
                    >
                      {{ item.totalGrade }}
                    </v-chip>
                    <v-chip
                      v-else
                      size="x-small"
                      color="error"
                      variant="flat"
                      class="font-weight-bold px-2 py-2"
                    >
                      Сбой
                    </v-chip>
                  </div>
                  <!-- Название модуля -->
                  <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                    Id: {{ item.esseId }}
                  </div>
                  <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                    Модуль: {{ item.moduleName }}
                  </div>
                  <div class="text-caption text-grey  w-100" style="max-width: 100%;">
                    Предмет: {{ item.subjectName }}
                  </div>
                  <div class="text-caption text-grey  w-100" style="max-width: 100%;">
                    Проба: {{ item.probeName }}
                  </div>
                  <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                    Попытка: {{ item.attempt }}
                  </div>
                  <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                    Промпт id: {{ item.promptId }}
                  </div>
                  <div class="text-caption text-grey  w-100" style="max-width: 100%;">
                    Промпт: {{ item.promptName }}
                  </div>
                    <v-chip size ="small" class="mr-2 mt-2"  color="red" v-if="item.solvedAsAssignment"> <v-icon icon="mdi-label" start></v-icon>Решено как задание</v-chip>
                    <v-chip size ="small" class="mr-2 mt-2"   color="red" v-if="item.conceptReplacedByFormat"> <v-icon icon="mdi-label" start></v-icon>Подмена понятий</v-chip>
                    <v-chip size ="small" class="mr-2 mt-2"   color="red" v-if="item.signsOfNonIndependentText"> <v-icon icon="mdi-label" start></v-icon>Не самостоятельная работа</v-chip>
                    <v-chip size ="small" class="mr-2 mt-2"  color="red" v-if="item.workNotSubmitted"> <v-icon icon="mdi-label" start></v-icon>Работа не представлена</v-chip>
                    <v-chip size ="small" class="mr-2 mt-2"   color="red" v-if="item.productDoesNotFitIntoModularTask"> <v-icon icon="mdi-label" start></v-icon>Не входит в мод. задачу</v-chip>
                </div>
                <!-- Нижняя часть карточки -->
                <div class="mt-3 pt-2 border-top-light">
                  <div class="d-flex align-center justify-space-between w-100">
                    <!-- Левая часть:  маркер статуса -->
                    <div class="flex-grow-1 mr-2 text-truncate">
                      <span v-if="item.status === 'CHECKED'" class="text-caption text-success font-weight-medium">
                        <v-icon size="x-small" color="success" start>mdi-check-circle-outline</v-icon> Проверено
                      </span>
                      <span v-else class="text-caption text-error font-weight-medium">
                        <v-icon size="x-small" color="error" start>mdi-alert-circle-outline</v-icon> Сбой
                      </span>
                    </div>
                    <!-- Правая часть: Блок иконок -->
                    <div class="d-flex align-center gap-1 flex-grow-0 flex-shrink-0">
                      <v-btn
                       icon="mdi-file-document-outline"
                       size="x-small"
                       variant="tonal"
                       color="deep-orange-darken-1"
                       density="comfortable"
                       class="rounded-md ma-1"
                       style="min-width: 28px; width: 28px; height: 28px;"
                       title="Скачать"
                        @click="downloadDocument(item)"
                      ></v-btn>
                      <v-btn
                        v-if="item.status === 'CHECKED'"
                        icon="mdi-eye-outline"
                        size="x-small"
                        variant="tonal"
                        color="deep-orange-darken-1"
                        density="comfortable"
                        class="rounded-md ma-1"
                        style="min-width: 28px; width: 28px; height: 28px;"
                        title="Посмотреть рецензию ИИ"
                        @click="viewEssayDetails(item.esseId)"
                      ></v-btn>
                      <v-btn
                        icon="mdi-cached"
                        size="x-small"
                        variant="outlined"
                        color="info"
                        density="comfortable"
                        class="rounded-md ma-1"
                        style="min-width: 28px; width: 28px; height: 28px;"
                        title="Запустить повторную проверку ИИ"
                        @click="recheckEssay(item.esseId)"
                      ></v-btn>
                      <v-btn
                        icon="mdi-delete"
                        size="x-small"
                        variant="outlined"
                        color="red"
                        density="comfortable"
                        class="rounded-md ma-1"
                        style="min-width: 28px; width: 28px; height: 28px;"
                        title="Удалить"
                        @click="deleteEssay(item.esseId)"
                      ></v-btn>
                    </div>
                  </div>
                </div>
              </v-card>
              <!-- Заглушка, если колонка пуста -->
              <div v-if="getColCount('CHECKED') === 0" class="text-center text-caption text-grey py-8 font-italic">
                Нет проверенных работ
              </div>
            </div>
          </v-card>
        </v-col>
        <!-- КОЛОНКА 5: падшие (CHECKED / FAIL_CHECK / SYSTEM_ERROR) -->
        <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="pa-2" v-if="getFailedItems.length>0">
          <v-card variant="flat" color="red-lighten-5" class="pa-3 rounded-lg h-100 d-flex flex-column">
            <!-- Шапка колонки -->
            <div class="d-flex align-center justify-space-between mb-3">
              <span class="text-subtitle-1 font-weight-bold text-red-darken-3">Ошибки проверки</span>
            </div>
            <v-divider class="mb-3"></v-divider>
            <!-- Скролл-зона с карточками студентов -->
            <div class="kanban-scroll-zone flex-grow-1">
              <v-card
                v-for="item in getFailedItems()"
                :key="item.esseId"
                class="mb-2 pa-3 rounded-lg border bg-white d-flex flex-column justify-space-between border-left-red"
                variant="flat"
                style="min-height: 140px;"
              >

                <!-- Верхняя часть карточки: ФИО и Оценка -->
                <div>
                  <div class="d-flex justify-space-between align-start w-100 mb-1">

                    <!-- ФИО студента (переносится по словам, если не влезает) -->
                    <div class="font-weight-bold text-body-2 pr-2 text-wrap" style="word-break: break-word; line-height: 1.3;">
                      {{ item.studentFullName }}
                    </div>
                    <!-- Вывод итоговой оценки или плашки сбоя -->
                    <v-chip
                      v-if="item.status === 'CHECKED'"
                      size="x-small"
                      color="success"
                      variant="flat"
                      class="font-weight-bold px-2 py-2"
                    >
                      {{ item.totalGrade }}
                    </v-chip>
                    <v-chip
                      v-else
                      size="x-small"
                      color="error"
                      variant="flat"
                      class="font-weight-bold px-2 py-2"
                    >
                      Сбой
                    </v-chip>
                  </div>

                  <!-- Название модуля -->
                  <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                    Id: {{ item.esseId }}
                  </div>
                  <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                    Модуль: {{ item.moduleName }}
                  </div>
                  <div class="text-caption text-grey  w-100" style="max-width: 100%;">
                    Предмет: {{ item.subjectName }}
                  </div>
                  <div class="text-caption text-grey  w-100" style="max-width: 100%;">
                    Проба: {{ item.probeName }}
                  </div>
                  <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                    Попытка: {{ item.attempt }}
                  </div>
                  <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                    Промпт id: {{ item.promptId }}
                  </div>
                  <div class="text-caption text-grey  w-100" style="max-width: 100%;">
                    Промпт: {{ item.promptName }}
                  </div>
                </div>
                <!-- Нижняя часть карточки -->
                <div class="mt-3 pt-2 border-top-light">
                  <div class="d-flex align-center justify-space-between w-100">
                    <!-- Левая часть:  маркер статуса -->
                    <div class="flex-grow-1 mr-2 text-truncate">
                      <span class="text-caption text-error font-weight-medium">
                        <v-icon size="x-small" color="error" start>mdi-alert-circle-outline</v-icon> Сбой
                      </span>
                      {{item.status}}
                    </div>
                    <!-- Правая часть: Блок иконок -->
                    <div class="d-flex align-center gap-1 flex-grow-0 flex-shrink-0">
                      <v-btn
                        icon="mdi-file-document-outline"
                        size="x-small"
                        variant="tonal"
                        color="deep-orange-darken-1"
                        density="comfortable"
                        class="rounded-md ma-1"
                        style="min-width: 28px; width: 28px; height: 28px;"
                        title="Скачать"
                        @click="downloadDocument(item)"
                      ></v-btn>
                      <v-btn
                        v-if="item.status === 'CHECKED'"
                        icon="mdi-eye-outline"
                        size="x-small"
                        variant="tonal"
                        color="deep-orange-darken-1"
                        density="comfortable"
                        class="rounded-md ma-1"
                        style="min-width: 28px; width: 28px; height: 28px;"
                        title="Посмотреть рецензию ИИ"
                        @click="viewEssayDetails(item.esseId)"
                      ></v-btn>
                      <v-btn
                        icon="mdi-cached"
                        size="x-small"
                        variant="outlined"
                        color="info"
                        density="comfortable"
                        class="rounded-md ma-1"
                        style="min-width: 28px; width: 28px; height: 28px;"
                        title="Запустить повторную проверку ИИ"
                        @click="recheckEssay(item.esseId)"
                      ></v-btn>
                       <v-btn
                        icon="mdi-delete"
                        size="x-small"
                        variant="outlined"
                        color="red"
                        density="comfortable"
                        class="rounded-md ma-1"
                        style="min-width: 28px; width: 28px; height: 28px;"
                        title="Удалить"
                        @click="deleteEssay(item.esseId)"
                      ></v-btn>

                    </div>
                  </div>
                </div>
              </v-card>
              <!-- Заглушка, если колонка пуста -->
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="pa-2" v-if="getFailedItems">
              <v-card variant="flat" color="red-lighten-5" class="pa-3 rounded-lg h-100 d-flex flex-column">
                <!-- Шапка колонки -->
                <div class="d-flex align-center justify-space-between mb-3">
                  <span class="text-subtitle-1 font-weight-bold text-red-darken-3">Ошибки проверки</span>
                </div>
                <v-divider class="mb-3"></v-divider>
                <!-- Скролл-зона с карточками студентов -->
                <div class="kanban-scroll-zone flex-grow-1">
                  <v-card
                    v-for="item in getFailedItems()"
                    :key="item.esseId"
                    class="mb-2 pa-3 rounded-lg border bg-white d-flex flex-column justify-space-between border-left-red"
                    variant="flat"
                    style="min-height: 140px;"
                  >

                    <!-- Верхняя часть карточки: ФИО и Оценка -->
                    <div>
                      <div class="d-flex justify-space-between align-start w-100 mb-1">

                        <!-- ФИО студента (переносится по словам, если не влезает) -->
                        <div class="font-weight-bold text-body-2 pr-2 text-wrap" style="word-break: break-word; line-height: 1.3;">
                          {{ item.studentFullName }}
                        </div>
                        <!-- Вывод итоговой оценки или плашки сбоя -->
                        <v-chip
                          v-if="item.status === 'CHECKED'"
                          size="x-small"
                          color="success"
                          variant="flat"
                          class="font-weight-bold px-2 py-2"
                        >
                          {{ item.totalGrade }}
                        </v-chip>
                        <v-chip
                          v-else
                          size="x-small"
                          color="error"
                          variant="flat"
                          class="font-weight-bold px-2 py-2"
                        >
                          Сбой
                        </v-chip>
                      </div>

                      <!-- Название модуля -->
                      <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                        Id: {{ item.esseId }}
                      </div>
                      <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                        Модуль: {{ item.moduleName }}
                      </div>
                      <div class="text-caption text-grey  w-100" style="max-width: 100%;">
                        Предмет: {{ item.subjectName }}
                      </div>
                      <div class="text-caption text-grey  w-100" style="max-width: 100%;">
                        Проба: {{ item.probeName }}
                      </div>
                      <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                        Попытка: {{ item.attempt }}
                      </div>
                      <div class="text-caption text-grey text-truncate w-100" style="max-width: 100%;">
                        Промпт id: {{ item.promptId }}
                      </div>
                      <div class="text-caption text-grey  w-100" style="max-width: 100%;">
                        Промпт: {{ item.promptName }}
                      </div>
                    </div>
                    <!-- Нижняя часть карточки -->
                   <div class="mt-3 pt-2 border-top-light">
                                     <div class="d-flex align-center justify-space-between w-100">
                                       <!-- Левая часть:  маркер статуса -->
                                       <div class="flex-grow-1 mr-2 text-truncate">
                                       {{item.status}}
                                       </div>
                                       <!-- Правая часть: Блок иконок -->
                                       <div class="d-flex align-center gap-1 flex-grow-0 flex-shrink-0">
                                         <v-btn
                                           icon="mdi-file-document-outline"
                                           size="x-small"
                                           variant="tonal"
                                           color="deep-orange-darken-1"
                                           density="comfortable"
                                           class="rounded-md ma-1"
                                           style="min-width: 28px; width: 28px; height: 28px;"
                                           title="Скачать"
                                           @click="downloadDocument(item)"
                                         ></v-btn>
                                         <v-btn
                                           icon="mdi-cached"
                                           size="x-small"
                                           variant="outlined"
                                           color="info"
                                           density="comfortable"
                                           class="rounded-md ma-1"
                                           style="min-width: 28px; width: 28px; height: 28px;"
                                           title="Запустить повторную проверку ИИ"
                                           @click="recheckEssay(item.esseId)"
                                         ></v-btn>
                                         <v-btn
                                           icon="mdi-delete"
                                           size="x-small"
                                           variant="outlined"
                                           color="red"
                                           density="comfortable"
                                           class="rounded-md ma-1"
                                           style="min-width: 28px; width: 28px; height: 28px;"
                                           title="Удалить"
                                           @click="deleteEssay(item.esseId)"
                                         ></v-btn>
                                       </div>
                                     </div>
                                   </div>
                  </v-card>
                  <!-- Заглушка, если колонка пуста -->
                </div>
              </v-card>
            </v-col>
      </v-row>
    </div>
    <!-- ДОБАВИТЬ ЭТОТ БЛОК: Закрытие полноэкранного v-dialog рецензии ИИ -->
    <v-dialog v-model="detailsDialog" fullscreen transition="dialog-bottom-transition">
      <!-- ПОЛНОЭКРАННОЕ ОКНО: карта рецензирования эссе -->
      <v-card v-if="selectedEssay" class="bg-grey-lighten-4 font-sans">
        <!-- Шапка окна с полным ФИО и итоговым баллом -->
        <v-toolbar color="indigo-darken-4" dark elevation="2">
          <v-btn icon="mdi-close" variant="text" @click="detailsDialog = false"></v-btn>
          <v-toolbar-title class="text-subtitle-1 text-sm-h6 font-weight-bold">
            <v-icon start class="mr-2">mdi-file-certificate-outline</v-icon>
            Рецензия: {{ selectedEssay.studentFullName }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div class="pa-3 pa-md-6" style="overflow-y: auto; height: calc(100vh - 64px);">
          <v-row class="ma-0">
            <!-- ЛЕВАЯ КАРТА: Текст эссе магистранта -->
            <v-col cols="12" md="6" class="pa-2">
              <v-card variant="flat" class="pa-4 pa-md-6 bg-white rounded-xl shadow-soft h-100">
                <v-card-title class="px-0 pt-0 text-h6 font-weight-bold text-indigo-darken-4 d-flex align-center">
                  <v-icon color="indigo" class="mr-2">mdi-text-account</v-icon>Текст эссе
                </v-card-title>
                <v-card-subtitle class="px-0 mb-4 text-caption text-grey-darken-1">
                  Модуль: {{ selectedEssay.moduleName }} | Сдано: {{ formatDateTime(selectedEssay.createdAt) }}
                </v-card-subtitle>
                <v-divider class="mb-5"></v-divider>
                <div style="white-space: pre-wrap; line-height: 1.7;" class="text-body-1 text-grey-darken-4 text-justify pr-2">
                  {{ selectedEssay.essayBody }}
                </div>
              </v-card>
            </v-col>
            <!-- ПРАВАЯ КАРТА: Разбор критериев  -->
            <v-col cols="12" md="6" class="pa-2">
              <v-card variant="flat" class="pa-4 pa-md-6 bg-white rounded-xl shadow-soft h-100 d-flex flex-column">
                <!-- Заголовок и итоговый балл -->
                <div class="d-flex justify-space-between align-center mb-4">
                  <div class="d-flex align-center">
                    <v-avatar color="indigo-lighten-5" class="mr-3" size="default">
                      <v-icon color="indigo">mdi-robot-outline</v-icon>
                    </v-avatar>
                    <div>
                      <span class="text-h6 font-weight-bold d-block text-indigo-darken-4" style="line-height: 1.2;">Аналитика ИИ</span>
                      <span class="text-caption text-grey">Автоматическая портфельная оценка</span>
                    </div>
                  </div>
                  <v-card variant="flat" color="indigo-lighten-5" class="pa-2 px-4 rounded-lg text-center">
                    <span class="text-caption text-indigo-darken-2 font-weight-medium d-block uppercase tracking-wider" style="font-size: 0.65rem !important;">Итоговый балл</span>
                    <span class="text-h4 font-weight-black text-indigo">{{ selectedEssay.totalGrade }} б.</span>
                  </v-card>
                </div>
                <v-divider class="mb-5"></v-divider>
                <!-- СПИСОК АТОМАРНЫХ ПОКАЗАТЕЛЕЙ ИЗ МАТРИЦЫ -->
                <div class="flex-grow-1">
                  <v-card
                    v-for="criterion in selectedEssay.criteriaResults"
                    :key="criterion.id"
                    variant="flat"
                    class="mb-4 rounded-xl border bg-grey-lighten-5 overflow-hidden"
                  >
                    <!-- Шапка показателя с оценкой -->
                    <div class="d-flex justify-space-between align-center px-4 py-3 bg-white border-bottom-light">
                      <span class="font-weight-black text-subtitle-1 text-indigo-darken-3">
                        <v-icon size="small" color="indigo" class="mr-1">mdi-bookmark-check-outline</v-icon>
                        Показатель №{{ criterion.criteriaOrder }}
                      </span>
                      <v-chip
                        size="small"
                        :color="criterion.criteriaRate > 1 ? 'success' : (criterion.criteriaRate == 1 ? 'warning' : 'error')"
                        variant="flat"
                        class="font-weight-bold px-3"
                      >
                        Оценка: {{ criterion.criteriaRate }} / 3 б.
                      </v-chip>
                    </div>
                    <!-- Развернутый структурированный текст рецензии ИИ -->
                    <v-card-text class="pa-4 bg-grey-must-lighten-5">
                      <div style="white-space: pre-wrap; line-height: 1.6;" class="text-body-2 text-grey-darken-3 custom-review-text pl-1">
                        {{ criterion.criteriaRateDescription }}
                      </div>
                    </v-card-text>
                  </v-card>
                  <!-- Сообщение, если логи пустые -->
                  <v-alert
                    v-if="!selectedEssay.criteriaResults || selectedEssay.criteriaResults.length === 0"
                    type="warning"
                    variant="tonal"
                    class="rounded-xl mt-2 text-body-2"
                  >
                    Детальные критерии оценивания отсутствуют. Проверьте лог работы приложения.
                  </v-alert>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { formatDateTime } from "@/util/common";
import PageTitle from "@/elements/PageTitle.vue";
import { customAxios } from "@/service/customAxios";
import { usePopupStore } from "@/store/popup";
let refreshInterval = null;
const CURRENT_MODE = ref('IDLE'); // Режимы: 'IDLE' (пассивный) или 'ACTIVE' (активный)
const { showError } = usePopupStore();
// Реактивные состояния фильтров и данных
const courses = ref([]);
const groups = ref([]);
const results = ref([]);
const courseFilterData = ref([]);
const selectedModuleId = ref(null)
const selectedSubjectId = ref(null)
const selectedProbeId = ref(null)
const stats = ref(null);
const selectedCourseId = ref(null);
const selectedGroupId = ref(null);
const tableSearch = ref('');
const showLoader = ref(false);
// Управление развернутым диалогом
const detailsDialog = ref(false);
const selectedEssay = ref(null);

const loadingExcel = ref(false);
const loadingPdf = ref(false);


// УМНЫЙ КЛИЕНТСКИЙ ПОИСК: фильтрует текущие строки на лету без спама запросами в БД
const filteredResults = computed(() => {
  const q = tableSearch.value ? tableSearch.value.trim().toLowerCase() : '';
  if (!q) return results.value;
  return results.value.filter(r =>
    r.studentFullName && r.studentFullName.toLowerCase().includes(q)
  );
});
// Безопасный расчет предметов
const availableSubjects = computed(() => {
  // Проверяем, что корень — это массив и в нем есть данные
  if (!selectedModuleId.value || !Array.isArray(courseFilterData.value)) return []
  const currentModule = courseFilterData.value.find(m => m?.id === selectedModuleId.value)
  // Если у модуля нет subjects или это не массив, вернем пустой список
  return Array.isArray(currentModule?.subjects) ? currentModule.subjects : []
})
// Безопасный расчет проб
const availableProbes = computed(() => {
  if (!selectedSubjectId.value || !Array.isArray(availableSubjects.value)) return []
  const currentSubject = availableSubjects.value.find(s => s?.id === selectedSubjectId.value)
  return Array.isArray(currentSubject?.probes) ? currentSubject.probes : []
})
// Хэндлеры сброса
const onCourseFilterChange = async (courseId) => {
  selectedModuleId.value = null
  selectedSubjectId.value = null
  selectedProbeId.value = null
  courseFilterData.value = [] // Временно очищаем перед запросом
  if (courseId) {
    try {
      // Вызываем твою функцию получения данных
      await fetchCourseFilterData(courseId)
    } catch (e) {
      console.error('Ошибка загрузки фильтров курса:', e)
    }
  }
  onFilterChange()
}
const onModuleFilterChange = () => {
  selectedSubjectId.value = null
  selectedProbeId.value = null
  onFilterChange()
}
const onSubjectFilterChange = () => {
  selectedProbeId.value = null
  onFilterChange()
}
//const onFilterChange = () => {
// Твой метод запроса основных данных для дашборда
// fetchDashboardData(); //}
//** _Фильтрует элементы для конкретной колонки с учетом строки поиска_ /
function getColItems(columnStatus) {
  if (!filteredResults.value) return [];
  if (columnStatus === 'CHECKED') {
    return filteredResults.value.filter(item => item.status === 'CHECKED' || item.status === 'FAIL_CHECK' || item.status === 'SYSTEM_ERROR');
  }
  return filteredResults.value.filter(item => item.status === columnStatus);
}
function getFailedItems() {
  if (!filteredResults.value) return [];

  // Список всех ошибочных статусов
  const errorStatuses = [
    'SYSTEM_ERROR',
    'SYSTEM_ERROR_CRITERIES_COUNT_MISMATCH',
    'SYSTEM_ERROR_NO_CRITERIES',
    'PROMPT_INJECTION_DETECTED',
    'SYSTEM_ERROR_NETWORK'
  ];

  return filteredResults.value.filter(item => {
    // Безопасная проверка: приводим к строке, убираем пробелы и проверяем наличие в списке
    const status = String(item?.status).trim();
    return errorStatuses.includes(status);
  });
}
//** _Считает количество карточек в колонке_ /
function getColCount(columnStatus) {
  return getColItems(columnStatus).length;
}
//** _1. Инициализация выпадающих списков фильтров_ /
async function initFilters() {
  try {
    const [cRes, gRes] = await Promise.all([
      customAxios.get('/v1/admin/courses'),
      customAxios.get('/user_group')
    ]);
    courses.value = cRes.data || [];
    groups.value = gRes.data || [];
  } catch (e) {
    console.error("Ошибка при инициализации фильтров:", e);
  }
}
//** _5. Запуск принудительной перепроверки эссе через DeepSeek_ /
async function recheckEssay(esseId) {
  if (!confirm("Вы уверены, что хотите стереть текущую оценку и отправить работу на повторную ИИ-проверку?")) return;
  showLoader.value = true;
  try {
    const r = await customAxios.post(`/v1/admin/results/essay/${esseId}/recheck`);
    if (r.status === 200) {
      alert("Работа успешно добавлена в очередь! ИИ перепроверит её в течение 1-2 минут.");
      await fetchDashboardData();
    }
  } catch (e) {
    showError(e);
  } finally {
    showLoader.value = false;
  }
}
//** _6. Удаляем_ /
async function deleteEssay(esseId) {
  if (!confirm("Вы уверены, что хотите удалить эссе?")) return;
  showLoader.value = true;
  try {
    const r = await customAxios.delete(`/v1/admin/results/essay/${esseId}`);
    if (r.status === 200 || r.status === 202) {
      alert("Эссе удалено!");
      await fetchDashboardData();
    }
  } catch (e) {
    showError(e);
  } finally {
    showLoader.value = false;
  }
}

async function downloadDocument(esse){
 // isLoading.value = true;
 // errorMessage.value = '';

  try {
    // 1. Делаем запрос к Spring Boot.
    // КРИТИЧЕСКИ ВАЖНО указать responseType: 'blob'
    const response = await customAxios.get('/v1/admin/results/download/doc/' + esse.esseId, {
      responseType: 'blob'
    });

    // 2. Создаем Blob объект из полученных данных
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    });

    // 3. Создаем временную URL-ссылку в памяти браузера
    const downloadUrl = window.URL.createObjectURL(blob);

    // 4. Создаем невидимый тег <a>, кликаем по нему и удаляем
    const link = document.createElement('a');
    link.href = downloadUrl;

    // Имя файла (можно захардкодить или вытащить из заголовка Content-Disposition)
    let fileName = esse.studentFullName + '_' + esse.subjectName + '_' + esse.probeName + '.docx';
    link.setAttribute('download', fileName);

    document.body.appendChild(link);
    link.click();

    // Очищаем память и удаляем элемент
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

  } catch (error) {
    console.error('Ошибка при скачивании файла:', error);

  }
}
async function fetchCourseFilterData(){
  try {
    const r = await customAxios.get('/v1/courses/for_filter/' + selectedCourseId.value);
    console.log("r:" + r)
    if (r.status === 200) courseFilterData.value = r.data || [];
  } catch (e) {
    showError(e);
    courseFilterData.value = [];
  } finally {
    showLoader.value = false;
  }
}
//** _2. Комплексный POST-запрос данных таблицы и KPI аналитики_ /
async function fetchDashboardData() {
  if (results.value.length === 0) showLoader.value = true;
  try {
    const payload = {
      courseId: selectedCourseId.value || null,
      groupId: selectedGroupId.value || null,
      moduleId: selectedModuleId.value || null,
      subjectId: selectedSubjectId.value || null,
      probeId: selectedProbeId.value || null,
    };
    const [resData, resStats] = await Promise.all([
      customAxios.post('/v1/admin/results', payload),
      customAxios.post('/v1/admin/results/stats', payload)
    ]);
    if (resData.status === 200) results.value = resData.data || [];
    if (resStats.status === 200) stats.value = resStats.data;
    // Проверяем, есть ли на доске процессы проверки ИИ прямо сейчас
    const hasActiveAiProcess = results.value.some(r => r.status === 'SENT' || r.status === 'IN_WORK');
    // Передаем флаг в умный диспетчер режимов
    setupSmartRefresh(hasActiveAiProcess);
  } catch (e) {
    showError(e);
    results.value = [];
    stats.value = null;
  } finally {
    showLoader.value = false;
  }
}

async function downloadReport(type) {
  // Включаем нужный лоадер
  if (type === 'excel') loadingExcel.value = true;
  if (type === 'pdf') loadingPdf.value = true;

  try {
    // Отправляем запрос на бэкенд. Обязательно указываем responseType: 'blob'
      const payload = {
          courseId: selectedCourseId.value || null,
          groupId: selectedGroupId.value || null,
          moduleId: selectedModuleId.value || null,
          subjectId: selectedSubjectId.value || null,
          probeId: selectedProbeId.value || null,
        };
    const response = await customAxios.post(`/v1/admin/results/download/${type}`, payload, {
      responseType: 'blob',
    });

    // Создаем ссылку в памяти для скачивания файла
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    // Задаем имя файла в зависимости от типа
    if(type === 'excel'){
     link.setAttribute('download', `report_${Date.now()}.${'xlsx'}`);
    } else if(type === 'pdf'){
     link.setAttribute('download', `report_${Date.now()}.${'pdf'}`);
    } else {
     link.setAttribute('download', `report_${Date.now()}.${'docx'}`);
    }

    // Добавляем ссылку на страницу, кликаем по ней и удаляем
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Освобождаем память
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(`Ошибка при скачивании ${type}:`, error);
    alert('Не удалось скачать файл. Попробуйте позже.');
  } finally {
    // Выключаем лоадеры
    loadingExcel.value = false;
    loadingPdf.value = false;
  }
}



function setupSmartRefresh(isAiActive) {
  // Вычисляем целевой режим и задержку
  const targetMode = isAiActive ? 'ACTIVE' : 'PASSIVE';
  const delay = isAiActive ? 15000 : 60000;
  // Если режим не изменился — ничего не трогаем, пусть текущий интервал тикает
  if (CURRENT_MODE.value === targetMode && refreshInterval) return;
  // Если режим изменился (или это первый запуск) — перезапускаем интервал
  if (refreshInterval) clearInterval(refreshInterval);
  CURRENT_MODE.value = targetMode;
  console.log(`📡 Канбан перешел в режим: [${targetMode}]. Интервал опроса: ${delay / 1000} сек.`);
  refreshInterval = setInterval(async () => {
    await fetchDashboardData();
  }, delay);
}
function onFilterChange() {
  if (refreshInterval) clearInterval(refreshInterval);
  refreshInterval = null;
  CURRENT_MODE.value = 'IDLE';
  fetchDashboardData();
}
function stopSmartRefresh() {
  if (refreshInterval) {
    clearInterval(refreshInterval);
    refreshInterval = null;
  }
  CURRENT_MODE.value = 'IDLE';
}
onBeforeUnmount(() => {
  stopSmartRefresh(); // Полностью глушим фоновые потоки при переходе на другую страницу
});
//** _3. Открытие детальной рецензии_ /
async function viewEssayDetails(esseId) {
  try {
    const r = await customAxios.get(`/v1/admin/results/essay/${esseId}`);
    if (r.status === 200) {
      selectedEssay.value = r.data;
      detailsDialog.value = true;
    }
  } catch (e) {
    showError(e);
  }
}
//** _4. Сверхбыстрая генерация Excel-ведомости (CSV) с BOM-байтами для Excel_ /

onMounted(async () => {
  // Первоначально подгружаем селекты, а затем выгружаем дашборд
  try {
    const gRes = await customAxios.get('/user_group');
    groups.value = gRes.data || [];
    const cRes = await customAxios.get('/v1/admin/courses');
    courses.value = cRes.data || [];
  } catch(e) { console.log(e); }
  await fetchDashboardData();
});
onMounted(async () => {
  await initFilters();
  // Выгружаем данные таблицы и KPI-аналитики для дашборда
  await fetchDashboardData();
});
</script>

<style scoped>

.gap-2 {
  gap: 8px !important; /* Отступ между кнопками в 8 пикселей */
}
.flex-grow-1 {
  flex-grow: 1 !important; /* Кнопка «Рецензия» растягивается на всё свободное место */
}
.mr-2 {
  margin-right: 8px !important; /* Фиксированный зазор между кнопкой просмотра и ретраем */
}
.rounded-md {
  border-radius: 6px !important; /* Скругление кнопок в едином стиле с карточками */
}
/* Линии отрыва и границы */
.border-top-light {
  border-top: 1px solid rgba(0, 0, 0, 0.08); /* Линия отрыва блока кнопок */
}
/* Стили для цветных вертикальных линий у KPI карточек */
.border-left-blue { border-left: 5px solid #1867c0 !important; }
.border-left-green { border-left: 5px solid #4caf50 !important; }
.border-left-amber { border-left: 5px solid #ff9800 !important; }
.border-left-purple { border-left: 5px solid #9c27b0 !important; }
.border-left-red { border-left: 4px solid rgb(var(--v-theme-error)) !important; }
/* Зона прокрутки Канбан-колонок */
.kanban-scroll-zone {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 4px;
}
/* Стилизация скроллбара для Канбана */
.kanban-scroll-zone::-webkit-scrollbar {
  width: 4px;
}
.kanban-scroll-zone::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
/* Анимации лоадеров ИИ */
.v-chip--loading :deep(.v-icon) {
  animation: spin 2s linear infinite;
}
@keyframes spin {
  100__ { transform: rotate(360deg); }
}
</style>